import { render, staticRenderFns } from "./settings-google.vue?vue&type=template&id=cd5d80f6&"
import script from "./settings-google.vue?vue&type=script&lang=js&"
export * from "./settings-google.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports